import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { UserService } from '@app/services/user.service';
import { AppRoutes } from '@shared/constants/app-routes.const';
import { PermissionLevelType } from '@shared/enums/permission-level.enum';
import { UserType } from '@shared/enums/user-type';
import { checkPermissionLevel } from '@shared/functions/check-permission-level.function';
import { UserData } from '@shared/interfaces/user-data';

@Injectable({
  providedIn: 'root',
})
export class HomeRedirectGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.userService.getUserData().pipe(
      filter((userData: UserData) => !!userData),
      map((userData: UserData) => {
        const permissionLevel: PermissionLevelType[] = userData.permissionLevel;
        const navigationExtras = { queryParams: route.queryParams, fragment: route.fragment };
        if (userData.userType === UserType.Employee) {
          if (checkPermissionLevel(permissionLevel, PermissionLevelType.AllPermissions)) {
            return this.router.createUrlTree([AppRoutes.ROLES_ADMIN_HOME], navigationExtras);
          }

          if (checkPermissionLevel(permissionLevel, PermissionLevelType.AssetManager_PropertyDashboard_Read)) {
            return this.router.createUrlTree([AppRoutes.ROLES_ASSET_HOME], navigationExtras);
          }

          if (checkPermissionLevel(permissionLevel, PermissionLevelType.ConstructionManager_Dashboard_Read)) {
            return this.router.createUrlTree([AppRoutes.ROLES_CONSTRUCTION_HOME], navigationExtras);
          }

          if (checkPermissionLevel(permissionLevel, PermissionLevelType.PropertyManager_Dashboard_Read)) {
            return this.router.createUrlTree([AppRoutes.ROLES_PROPERTY_HOME], navigationExtras);
          }
        }

        if (userData.userType === UserType.Contractor) {
          if (checkPermissionLevel(permissionLevel, PermissionLevelType.Turnovers_Kanban_Read)) {
            return this.router.createUrlTree([AppRoutes.ROLES_VENDOR_HOME], navigationExtras);
          }
        }
        return true;
      })
    );
  }
}
